// eslint-disable-next-line no-extend-native
export const getEntity = function (object, path, separator = '.') {
  const properties = Array.isArray(path) ? path : path
    .replace(/\[(\w+)]/g, '.$1').replace(/^\./, '')
    .split(separator)
  return properties.reduce((prev, curr) => prev?.[curr], object)
}
